/* eslint-disable no-unused-vars */
export enum RunTypes {
    ALLOCATION = 'allocation',
    CALCULATION = 'calculation',
    JOIN = 'join',
    MERGE = 'merge',
}
